// App.js - v2 with Feeds feature
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Materials from './pages/Materials';
import Goals from './pages/Goals';
import GoalDetail from './pages/GoalDetail';
import Daily from './pages/Daily';
import Checkin from './pages/Checkin';
import { WritingList, WritingEditor } from './pages/Writing';
import { FeedsList, FeedDetail } from './pages/Feeds';
import Login from './pages/Login';

const ProtectedApp = () => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div style={{ 
        minHeight: '100vh', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        background: 'var(--color-ivory)'
      }}>
        <div className="loading-spinner" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Login />;
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/materials" element={<Materials />} />
        <Route path="/goals" element={<Goals />} />
        <Route path="/goals/:id" element={<GoalDetail />} />
        <Route path="/daily" element={<Daily />} />
        <Route path="/writing" element={<WritingList />} />
        <Route path="/writing/:id" element={<WritingEditor />} />
        <Route path="/feeds" element={<FeedsList />} />
        <Route path="/feeds/:id" element={<FeedDetail />} />
        <Route path="/checkin" element={<Checkin />} />
      </Routes>
    </Layout>
  );
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <ProtectedApp />
      </Router>
    </AuthProvider>
  );
}

export default App;
